import $ from 'jquery'

// Location_type. The estate, building, floor and room selects cascade
// through cascade-select.js.
// ---------------------------------------------------------------------

$(document).on('turbo:load turbo:render', () => {
  const selectLocationType = $('.select_location_type')
  const selectEstateGroup = $('.select_estate')
  const selectEstate = $('.select_location_estate')
  const selectBuildingGroup = $('.select_building')
  const selectBuilding = $('.select_location_building')
  const selectFloorGroup = $('.select_floor')
  const selectFloor = $('.select_location_floor')
  const selectRoomGroup = $('.select_room')
  const selectRoom = $('.select_location_room')
  const inputRoomNameGroup = $('.input_room_name')
  const inputRoomName = $('.select_location_room_name')
  const selectVehicleGroup = $('.select_vehicle')
  const selectVehicle = $('.select_location_vehicle')
  const selectEquipmentGroup = $('.select_equipment')
  const selectEquipment = $('.select_location_equipment')

  // The select tag last in a certain cascade, for example when we set 'Floor' as location_type, needs a certain name the be valid and get recoginized within the params hash. As this script is used for in different places, QrCode form, Maintenance record form, etc., we extract it from a hidden field within select_location.html
  const activeSelectLocationIdName = $('#active_select_location_id_name').attr('name')

  selectLocationType.off('change.selectLocationType').on('change.selectLocationType', () => {
    // First disable everything and show only selectEstateGroup
    selectEstateGroup.removeClass('d-none')
    selectEstate.attr('name', 'disabled')
    selectBuildingGroup.addClass('d-none')
    selectBuilding.attr('name', 'disabled')
    selectFloorGroup.addClass('d-none')
    selectFloor.attr('name', 'disabled')
    selectRoomGroup.addClass('d-none')
    selectRoom.attr('name', 'disabled')
    inputRoomNameGroup.addClass('d-none')
    inputRoomName.attr('disabled', true)
    selectVehicleGroup.addClass('d-none')
    selectVehicle.attr('name', 'disabled')
    selectEquipmentGroup.addClass('d-none')
    selectEquipment.attr('name', 'disabled')
    // … then enable conditionally
    switch (selectLocationType.val()) {
      case 'Estate':
        selectEstate.attr('name', activeSelectLocationIdName)
        break
      case 'Building':
        selectBuildingGroup.removeClass('d-none')
        selectBuilding.attr('name', activeSelectLocationIdName)
        break
      case 'Floor':
        selectBuildingGroup.removeClass('d-none')
        selectFloorGroup.removeClass('d-none')
        selectFloor.attr('name', activeSelectLocationIdName)
        inputRoomNameGroup.removeClass('d-none')
        inputRoomName.attr('disabled', false)
        break
      case 'Room':
        selectBuildingGroup.removeClass('d-none')
        selectFloorGroup.removeClass('d-none')
        selectRoomGroup.removeClass('d-none')
        selectRoom.attr('name', activeSelectLocationIdName)
        break
      case 'Vehicle':
        selectEstateGroup.addClass('d-none')
        selectVehicleGroup.removeClass('d-none')
        selectVehicle.attr('name', activeSelectLocationIdName)
        break
      case 'Equipment':
        selectEstateGroup.addClass('d-none')
        selectEquipmentGroup.removeClass('d-none')
        selectEquipment.attr('name', activeSelectLocationIdName)
        break
    }
  })

  // IMPORTANT
  // Also trigger everything after page (re)load, e.g. validation fail
  selectLocationType.trigger('change')
})
